/**
 * AuthGate — экраны «нет сессии» / «нет доступа» для SSO через Rover.
 *
 * unauthorized: живой cookie Rover нет → ведём логиниться в Orees Cloud на
 * родительском домене (он и ставит кросс-доменную cookie, после чего Vision
 * открывается без отдельного входа). forbidden: сессия есть, но раздел Vision
 * (section.vision) пользователю не выдан — просить администратора, не логин.
 */
import { Button } from "@/components/ui/Button";
import { roverLoginUrl } from "@/api/session";

export function AuthGate({ kind }: { kind: "unauthorized" | "forbidden" }) {
  const loginUrl = roverLoginUrl();

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas p-6">
      <div className="w-full max-w-sm rounded-card border border-border bg-surface p-6 text-center shadow-sm">
        <h1 className="text-lg font-semibold text-ink">Orees Vision</h1>

        {kind === "forbidden" ? (
          <p className="mt-3 text-sm text-muted">
            У вашей учётной записи нет доступа к разделу Vision. Попросите
            администратора выдать право «Vision» вашей роли в Orees Cloud.
          </p>
        ) : (
          <>
            <p className="mt-3 text-sm text-muted">
              Войдите в Orees Cloud — Vision использует общую сессию, отдельного
              входа нет.
            </p>
            {loginUrl ? (
              <a href={loginUrl} className="mt-5 block">
                <Button block>Войти через Orees</Button>
              </a>
            ) : (
              <p className="mt-4 text-xs text-muted">
                Дев-режим: задайте VITE_USER_TOKEN (например,{" "}
                <code>manager:&lt;restaurant_id&gt;</code>) или откройте дашборд
                на vision.&lt;домен&gt;.
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
